module.exports = __webpack_public_path__ + "routes/urzad/szczegolyUrzedu/logo_cmentarz.png?6b7cc5da";


//////////////////
// WEBPACK FOOTER
// ./routes/urzad/szczegolyUrzedu/logo_cmentarz.png
// module id = 1756
// module chunks = 0